import { lazy } from 'react'
import { chunkTracker } from '../../shared/utils/bundleAnalysis'

// Lazy load all feature pages for code splitting
export const LazyDashboardPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('DashboardPage')
  return import('../../features/dashboard/pages/DashboardPage')
})

export const LazyHousesPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('HousesPage')
  return import('../../features/houses/pages/HousesPage').then(module => ({ 
    default: module.HousesPage 
  }))
})

export const LazyHouseDetailsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('HousesDetailsPage')
  return import('../../features/houses/pages/HouseDetailsPage').then(module => ({ 
    default: module.HouseDetailsPage 
  }))
})

export const LazyEditHousePage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('EditHousesPage')
  return import('../../features/houses/pages/EditHousePage').then(module => ({ 
    default: module.EditHousePage 
  }))
})

export const LazyInvitationLandingPage = lazy(() =>
  import('../../features/auth/pages/InvitationLandingPage').then((module) => ({
    default: module.default,
  })),
);


export const LazyHousesManagementOverviewPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('HousesManagementOverviewPage')
  return import('../../features/houses/pages/HousesManagementOverviewPage').then(module => ({ 
    default: module.HousesManagementOverviewPage 
  }))
})

export const LazyHouseManagersPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('HouseManagersPage')
  return import('../../features/houses/pages/HouseManagersPage').then(module => ({ 
    default: module.HouseManagersPage 
  }))
})

export const LazyHouseManagerDetailsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('HouseManagerDetailsPage')
  return import('../../features/houses/pages/ManagerDatailsPage').then(module => ({ 
    default: module.ManagerDetailsPage 
  }))
})

export const LazyHouseResidentsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ManageResidentsPage')
  return import('../../features/residents/pages/ManageResidentsPage').then(module => ({ 
    default: module.ManageResidentsPage 
  }))
})

export const LazyHouseResidentDetailsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentDetailsPage')
  return import('../../features/residents/pages/ResidentDetailsPage').then(module => ({ 
    default: module.ResidentDetailsPage 
  }))
})

export const LazyEditHouseResidentPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('EditResidentPage')
  return import('../../features/residents/pages/EditResidentPage').then(module => ({ 
    default: module.EditResidentPage 
  }))
})

export const LazyResidentsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentsPage')
  return import('../../features/residents/pages/ResidentsPage').then(module => ({ 
    default: module.ResidentsPage 
  }))
})

export const LazyArchivedResidentsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ArchivedResidentsPage')
  return import('../../features/residents/pages/ArchivedResidentsPage').then(module => ({ 
    default: module.ArchivedResidentsPage 
  }))
})

export const LazyFinancialsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('FinancialsPage')
  return import('../../features/financials/pages/FinancialsPage').then(module => ({ 
    default: module.FinancialsPage 
  }))
})

export const LazyFinancialHistoryPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('FinancialHistoryPage')
  return import('../../features/financials/pages/FinancialHistoryPage').then(module => ({ 
    default: module.FinancialHistoryPage 
  }))
})

export const LazyResidentFinancialHistoryPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentFinancialHistoryPage')
  return import('../../features/financials/pages/ResidentFinancialHistoryPage').then(module => ({ 
    default: module.ResidentFinancialHistoryPage 
  }))
})

export const LazyFinancialReportPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('FinancialReportPage')
  return import('../../features/financials/pages/FinancialReportPage').then(module => ({ 
    default: module.FinancialReportPage 
  }))
})

export const LazyStripeConnectCallbackPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('StripeConnectCallbackPage')
  return import('../../features/financials/pages/StripeConnectCallbackPage').then(module => ({ 
    default: module.StripeConnectCallbackPage 
  }))
})

export const LazyAnnouncementsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('AnnouncementsPage')
  return import('../../features/announcements/pages/AnnouncementsPage').then(module => ({ 
    default: module.AnnouncementsPage 
  }))
})

export const LazyResidentAnnoucementsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentAnnoucementsPage')
  return import('../../features/announcements/pages/ResidentAnnoucementsPage').then(module => ({ 
    default: module.ResidentAnnoucementsPage 
  }))
})

export const LazyAllAnnoucementPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('AllAnnoucementPage')
  return import('../../features/announcements/pages/AllAnnoucementPage').then(module => ({ 
    default: module.AllAnnoucementPage 
  }))
})

export const LazyAnnoucementDetailPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('AnnoucementDetailPage')
  return import('../../features/announcements/pages/AnnoucementDetailPage').then(module => ({ 
    default: module.AnnoucementDetailPage 
  }))
})

export const LazyResidentAnnoucementDetailPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentAnnoucementDetailPage')
  return import('../../features/announcements/pages/ResidentAnnoucementDetailPage').then(module => ({ 
    default: module.ResidentAnnoucementDetailPage 
  }))
})

export const LazyResidentResourcesPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentResourcesPage')
  return import('../../features/residents/dashboard/pages/ResourcesPage').then(module => ({ 
    default: module.ResourcesPage 
  }))
})

export const LazyResidentResourceDetailsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentResourceDetailsPage')
  return import('../../features/residents/dashboard/pages/ResourceDetailsPage').then(module => ({ 
    default: module.ResourceDetailsPage 
  }))
})

export const LazyResourcesPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResourcesPage')
  return import('../../features/resources/pages/ResourcesPage')
})

export const LazyAllResourcesPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('AllResourcesPage')
  return import('../../features/resources/pages/AllResourcesPage')
})

export const LazyResourceDetailsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResourceDetailsPage')
  return import('../../features/resources/pages/ResourceDetailsPage')
})

export const LazySettingsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('SettingsPage')
  return import('../../features/settings/pages/SettingsPage')
})

// Auth pages
export const LazySignInPage = lazy(() => 
  import('../../features/auth/pages/SignInPage')
)

export const LazySignUpPage = lazy(() => 
  import('../../features/auth/pages/SignUpPage')
)

export const LazyForgotPasswordPage = lazy(() => 
  import('../../features/auth/pages/ForgotPasswordPage').then(module => ({ 
    default: module.ForgotPasswordPage 
  }))
)

export const LazyConfirmEmailPage = lazy(() => 
  import('../../features/auth/pages/ConfirmEmailPage').then(module => ({ 
    default: module.ConfirmEmailPage 
  }))
)

export const LazyLinkExpiredPage = lazy(() => 
  import('../../features/auth/pages/LinkExpiredPage').then(module => ({ 
    default: module.LinkExpiredPage 
  }))
)

export const LazyResetPasswordPage = lazy(() => 
  import('../../features/auth/pages/ResetPasswordPage').then(module => ({ 
    default: module.ResetPasswordPage 
  }))
)

// Onboarding pages
export const LazyRoleSelectionPage = lazy(() => 
  import('../../features/onboarding/pages/RoleSelectionPage')
)

export const LazyOrganizationSetupPage = lazy(() => 
  import('../../features/onboarding/pages/OrganizationSetupPage')
)

export const LazyFinalizePage = lazy(() => 
  import('../../features/onboarding/pages/FinalizePage')
)

export const LazyPackageSelectionPage = lazy(() => 
  import('../../features/onboarding/pages/PackageSelectionPage')
)

export const LazySubscriptionExpiredPage = lazy(() => 
  import('../../features/payments/pages/SubscriptionExpiredPage').then(module => ({
    default: module.SubscriptionExpiredPage
  }))
)

// Profile pages
export const LazyProfilePage = lazy(() => 
  import('../../features/profile/pages/ProfilePage')
)

export const LazyChangePasswordPage = lazy(() => 
  import('../../features/profile/pages/ChangePasswordPage')
)

/**
 * ---------------------------------------
 * RESIDENT DASHBOARD
 * ---------------------------------------
 */
export const LazyResidentOnboardingHousePage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentDashboardPage')
  return import('../../features/onboarding/pages/residents/FeaturedHousesPage').then(module => ({ 
    default: module.FeaturedHousesPage 
  }))
})

export const LazyResidentOnboardingHousesDetailsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('FeaturedHousesDetailsPage')
  return import('../../features/onboarding/pages/residents/FeaturedHousesDetailsPage').then(module => ({ 
    default: module.FeaturedHousesDetailsPage 
  }))
})

export const LazyResidentOnboardingHousePaymentPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('HousePaymentPage')
  return import('../../features/onboarding/pages/residents/HousePaymentPage').then(module => ({ 
    default: module.HousePaymentPage 
  }))
})

export const LazyResidentOnboardingPaymentSuccessPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('HousePaymentPage')
  return import('../../features/onboarding/pages/residents/PaymentSuccessPage').then(module => ({ 
    default: module.PaymentSuccessPage 
  }))
})

export const LazyResidentDashboardHomePage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentDashboardHomePage')
  return import('../../features/residents/dashboard/pages/DashboardPage').then(module => ({ 
    default: module.DashboardPage 
  }))
})

export const LazyManagerNoOrganizationPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ManagerNoOrganizationPage')
  return import('../../features/dashboard/pages/ManagerNoOrganizationPage').then(module => ({ 
    default: module.default 
  }))
})

export const LazyResidentExploreHousesPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentExploreHousesPage')
  return import('../../features/residents/dashboard/pages/ExploreHousesPage').then(module => ({ 
    default: module.ExploreHousesPage 
  }))
})

export const LazyResidentExploreHousesDetailsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentExploreHousesDetailsPage')
  return import('../../features/residents/dashboard/pages/ExploreHousesDetailsPage').then(module => ({ 
    default: module.ExploreHousesDetailsPage 
  }))
})

export const LazyResidentPaymentsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentPaymentsPage')
  return import('../../features/residents/dashboard/pages/PaymentsPage').then(module => ({ 
    default: module.PaymentsPage 
  }))
})

export const LazyResidentPaymentsHistoryPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentPaymentsPage')
  return import('../../features/residents/dashboard/pages/PaymentsHistoryPage').then(module => ({ 
    default: module.PaymentsHistoryPage 
  }))
})

export const LazyResidentPaymentDetailsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentPaymentsPage')
  return import('../../features/residents/dashboard/pages/PaymentDetailsPage').then(module => ({ 
    default: module.PaymentDetailsPage 
  }))
})

export const LazyResidentAnnouncementsPage = lazy(() => {
  chunkTracker.trackLazyComponentLoad('ResidentPaymentsPage')
  return import('../../features/residents/dashboard/pages/AnnouncementsPage').then(module => ({ 
    default: module.AnnouncementsPage 
  }))
})
